define("Modules/PageHeader", [`Module`, `module`], function (Super, Self) {
	const userLinkRoutes = {
		[`/home/events`]: `wallet`,
		[`/home/media`]: `media`,
		[`/home/wallet`]: `wallet`,

		[`/home`]: `account`,
		[`/home/profile`]: `account`,
		[`/home/orders`]: `account`,
		[`/home/transfers`]: `account`,
		[`/home/invoices`]: `account`,
		[`/home/memberships`]: `account`,
		[`/home/credits`]: `account`,
		[`/home/rewards`]: `account`,
		[`/home/payment`]: `account`,
		[`/home/payouts`]: `account`,
		[`/home/shipping`]: `account`,
		[`/home/documents`]: `account`,
		[`/home/settings`]: `account`,
	};

	return Super.inherit({
		namespace: Self.id,
		requires: [`User`, `ShoppingCart`],
		defaults: {
			leftLinks: [],
			show: true,
			showTixrLogo: true, // whether to insert the Tixr logo
			showAvatar: true,
			showSearch: false,
			showUserLinks: true,
			transition: `fade`,
			rightLinks: [],
		},
		constructor(setup) {
			const { App, User, container, data } = this;
			const { location } = document;
			const { leftLinks, rightLinks, showAvatar, showSearch, showUserLinks, showTixrLogo } = setup;
			const links = [];
			let showLanguageMenu = false;

			if (showTixrLogo) {
				leftLinks.unshift({
					type: `icon`,
					href: `/`,
					icon: `tixr`,
					customClass: `logo`,
					label: `home`,
				});
			}

			this.chain(leftLinks)
				.concat(rightLinks)
				.each((link) => {
					this.defaults(link, {
						id: this.uniqueId(),
						action: `customLink`,
						type: `text`,
						customClass: ``,
						mobile: true,
						desktop: true,
						app: true,
						tooltip: null,
					});

					if (this.isFunction(link.handler)) {
						link.href = `#`;
						links.push({
							id: link.id,
							options: link,
							owner: setup.owner,
							handler: link.handler,
						});

						delete link.handler; // avoid functions in this.data
					}
				});

			this.links = links;

			this.assign(data, {
				lastChanged: 0,
				leftLinks,
				rightLinks,
				scrolled: false,
				scrollThreshold: 20, // set an initial value, properly calculated below
				showAvatar,
				showLanguageMenu,
				showSearch,
				showUserLinks,
				showTixrLogo,
			});

			this.render();

			if (showUserLinks) {
				this.addClass(`display-user-links`);
			}
			if (!showUserLinks) {
				this.removeClass(`display-user-links`);
				this.hide({ target: this.get(`.user-links`) });
			}

			if (leftLinks.length === 0) {
				this.hide({ selector: `.left-links` });
			}
			if (rightLinks.length === 0) {
				this.hide({ selector: `.right-links` });
			}

			App.onScroll(({ scrollTop }) => {
				this.checkScroll(scrollTop);
			});

			if (setup.showAvatar) {
				this.create({
					namespace: `Modules/MenuDrawer`,
					setup: {
						container: this.get(`[name="side-drawer"]`, container),
						// theme: `DARK`,
						callbacks: {
							close: () => {
								const menuBtn = this.get(`[action="menu"]`);

								if (this.isObject(menuBtn)) {
									menuBtn.setAttribute(`aria-expanded`, `false`);
								}

								this.removeClass(`menu-open`);
							},
						},
					},
				});
			}

			data.pathname = location.pathname;
			this.checkHrefs();

			App.onPageChange((details) => {
				data.pathname = details.pathname;
				this.checkHrefs();
			});

			User.get({
				subscribe: true,
				then: (user) => {
					const isGuestUser = User.isGuestUser();

					if (isGuestUser) {
						this.handleLoggedOut();
					} else {
						this.handleLoggedIn(user);
					}
				},
				fail: this.handleLoggedOut,
			});
		},

		api: {
			checkHrefs: {
				value(evt) {
					this.removeClass(`selected`, this.select(`.user-links .selected`));

					// highlight link based on pathname
					const section = userLinkRoutes[window.location.pathname];
					if (section) {
						this.addClass(`selected`, this.get(`#${section}`));
					}
				},
			},

			checkScroll: {
				value(scrollTop) {
					const { data } = this;
					const { scrolled, scrollThreshold } = this.data;

					if (scrollTop > scrollThreshold) {
						if (!scrolled) {
							this.addClass(`scrolled`);
							data.scrolled = true;
						}
					} else {
						if (scrolled) {
							this.removeClass(`scrolled`);
							data.scrolled = false;
						}
					}
				},
			},

			handleLoggedIn: {
				value(user) {
					const { showUserLinks } = this.data;
					const menuLink = this.get(`[name="menu-link"]`);
					const userLinks = this.get(`.user-links`);

					if (this.isObject(menuLink)) {
						const label = this.get(`.initials > .label`, menuLink);

						this.addClass(`logged-in`, menuLink);
						label.innerHTML = user.avatar.initials;
					}

					if (showUserLinks && this.isObject(userLinks)) {
						this.show({ target: userLinks, transition: `fade` });
					}

					this.hide({ target: this.get(`.login`) });
				},
			},

			handleLoggedOut: {
				value() {
					const menuLink = this.get(`[name="menu-link"]`);
					const userLinks = this.get(`.user-links`);

					if (this.isObject(menuLink)) {
						this.removeClass(`logged-in`, menuLink);
					}

					if (this.isObject(userLinks)) {
						this.hide({ target: userLinks, transition: `fade` });
					}

					this.show({ target: this.get(`.login`) });
				},
			},
		},

		listeners: [
			{
				event: `click`,
				filter: `[action]`,
				handler(evt) {
					const { App, Time, data } = this;

					var target = evt.currentTarget,
						action = target.getAttribute(`action`),
						actions = this.select(`a[action]`),
						avatar = this.get(`.avatar`),
						link;

					this.each(actions, (action) => {
						this.removeClass(`selected`, action);
					});

					this.addClass(`selected`, target);

					if (this.isElement(avatar)) {
						this.removeClass(`hover`, avatar);
						data.lastChanged = Time.getTime();
					}

					switch (action) {
						case `menu`:
							this.addClass(`menu-open`);
							target.setAttribute(`aria-expanded`, `true`);
							break;

						case `custom-link`:
							link = this.find(this.links, {
								id: target.getAttribute(`id`),
							});

							if (!this.isObject(link)) {
								throw new Error(`Modules/PageHeader: No handler found for link`);
							}

							link.handler.call(link.owner, evt);
							break;

						case `search`:
							return App.loadOverlay({ type: `SiteSearch` }); // returning, no break

						case `close-menu`:
							this.removeClass(`menu-open`);
							break;

						case `login`:
							this.App.loadOverlay({
								type: `LogIn`,
								replace: true,
								setup: {
									mode: `default`,
								},
								done: true,
							});
					}
				},
			},
		],
	});
});

define("Modules/PageHeader.templates",["handlebars"], function(Handlebars) {

this["Templates"] = this["Templates"] || {};

this["Templates"]["Modules/PageHeader/main"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <li class=\""
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"mobile") : depth0),{"name":"unless","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":83},"end":{"line":1,"column":123}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"desktop") : depth0),{"name":"unless","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":123},"end":{"line":1,"column":166}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"app") : depth0),{"name":"unless","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":166},"end":{"line":1,"column":201}}})) != null ? stack1 : "")
    + "\"> "
    + ((stack1 = lookupProperty(helpers,"compare").call(alias1,(depth0 != null ? lookupProperty(depth0,"type") : depth0),"image",{"name":"compare","hash":{},"fn":container.program(8, data, 0),"inverse":container.program(15, data, 0),"data":data,"loc":{"start":{"line":1,"column":204},"end":{"line":1,"column":807}}})) != null ? stack1 : "")
    + " </li> ";
},"2":function(container,depth0,helpers,partials,data) {
    return "hide-mobile";
},"4":function(container,depth0,helpers,partials,data) {
    return " hide-desktop";
},"6":function(container,depth0,helpers,partials,data) {
    return " hide-app";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <a href=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"href") : depth0), depth0))
    + "\" class=\"image\" style=\"background-image: url('"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"src") : depth0), depth0))
    + "');\""
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"alt") : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":304},"end":{"line":1,"column":343}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"compare").call(alias3,(depth0 != null ? lookupProperty(depth0,"href") : depth0),"#",{"name":"compare","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":343},"end":{"line":1,"column":397}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"tooltip") : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":398},"end":{"line":1,"column":483}}})) != null ? stack1 : "")
    + "></a> ";
},"9":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " aria-label=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"alt") : depth0), depth0))
    + "\"";
},"11":function(container,depth0,helpers,partials,data) {
    return " action=\"custom-link\"";
},"13":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " data-tooltip-text=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"tooltip") : depth0), depth0))
    + "\" data-tooltip-position=\"bottom\"";
},"15":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"compare").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),"icon",{"name":"compare","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":489},"end":{"line":1,"column":795}}})) != null ? stack1 : "");
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <a id=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "\" href=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"href") : depth0), depth0))
    + "\" aria-label=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"label") : depth0), depth0))
    + "\" "
    + ((stack1 = lookupProperty(helpers,"compare").call(alias3,(depth0 != null ? lookupProperty(depth0,"href") : depth0),"#",{"name":"compare","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":572},"end":{"line":1,"column":626}}})) != null ? stack1 : "")
    + " class=\"type-icon "
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"customClass") : depth0),{"name":"if","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":644},"end":{"line":1,"column":685}}})) != null ? stack1 : "")
    + "\""
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"tooltip") : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":686},"end":{"line":1,"column":771}}})) != null ? stack1 : "")
    + "> "
    + alias2(lookupProperty(helpers,"getIcon").call(alias3,(depth0 != null ? lookupProperty(depth0,"icon") : depth0),{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":773},"end":{"line":1,"column":789}}}))
    + " </a> ";
},"17":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"customClass") : depth0), depth0));
},"19":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <li class=\""
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"mobile") : depth0),{"name":"unless","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1525},"end":{"line":1,"column":1565}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"desktop") : depth0),{"name":"unless","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1565},"end":{"line":1,"column":1608}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"app") : depth0),{"name":"unless","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1608},"end":{"line":1,"column":1643}}})) != null ? stack1 : "")
    + "\"> "
    + ((stack1 = lookupProperty(helpers,"compare").call(alias1,(depth0 != null ? lookupProperty(depth0,"type") : depth0),"button",{"name":"compare","hash":{},"fn":container.program(20, data, 0),"inverse":container.program(22, data, 0),"data":data,"loc":{"start":{"line":1,"column":1646},"end":{"line":1,"column":2688}}})) != null ? stack1 : "")
    + " </li> ";
},"20":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <a id=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "\" href=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"href") : depth0), depth0))
    + "\" aria-label=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"label") : depth0), depth0))
    + "\" class=\"button ux4 small\" theme=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"theme") : depth0), depth0))
    + "\""
    + ((stack1 = lookupProperty(helpers,"compare").call(alias3,(depth0 != null ? lookupProperty(depth0,"href") : depth0),"#",{"name":"compare","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1769},"end":{"line":1,"column":1823}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"tooltip") : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1823},"end":{"line":1,"column":1908}}})) != null ? stack1 : "")
    + "> "
    + alias2(lookupProperty(helpers,"getIcon").call(alias3,(depth0 != null ? lookupProperty(depth0,"icon") : depth0),{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":1910},"end":{"line":1,"column":1926}}}))
    + "<span class=\"button-label\">"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"label") : depth0), depth0)) != null ? stack1 : "")
    + "</span> </a> ";
},"22":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"compare").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),"icon-button",{"name":"compare","hash":{},"fn":container.program(23, data, 0),"inverse":container.program(25, data, 0),"data":data,"loc":{"start":{"line":1,"column":1977},"end":{"line":1,"column":2676}}})) != null ? stack1 : "");
},"23":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <a id=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "\" href=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"href") : depth0), depth0))
    + "\" aria-label=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"label") : depth0), depth0))
    + "\" class=\"button ux4 small icon-button\" theme=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"theme") : depth0), depth0))
    + "\""
    + ((stack1 = lookupProperty(helpers,"compare").call(alias3,(depth0 != null ? lookupProperty(depth0,"href") : depth0),"#",{"name":"compare","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":2121},"end":{"line":1,"column":2175}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"tooltip") : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":2175},"end":{"line":1,"column":2260}}})) != null ? stack1 : "")
    + "> "
    + alias2(lookupProperty(helpers,"getIcon").call(alias3,(depth0 != null ? lookupProperty(depth0,"icon") : depth0),{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":2262},"end":{"line":1,"column":2278}}}))
    + " </a> ";
},"25":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"compare").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),"icon",{"name":"compare","hash":{},"fn":container.program(26, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":2284},"end":{"line":1,"column":2676}}})) != null ? stack1 : "");
},"26":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <a id=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "\" href=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"href") : depth0), depth0))
    + "\" aria-label=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"label") : depth0), depth0))
    + "\" "
    + ((stack1 = lookupProperty(helpers,"compare").call(alias3,(depth0 != null ? lookupProperty(depth0,"href") : depth0),"#",{"name":"compare","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":2367},"end":{"line":1,"column":2421}}})) != null ? stack1 : "")
    + " class=\"type-icon button ux4 nav-link large"
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"customClass") : depth0),{"name":"if","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":2464},"end":{"line":1,"column":2505}}})) != null ? stack1 : "")
    + "\""
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"tooltip") : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":2506},"end":{"line":1,"column":2591}}})) != null ? stack1 : "")
    + " theme=\""
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"theme") : depth0),{"name":"if","hash":{},"fn":container.program(27, data, 0),"inverse":container.program(29, data, 0),"data":data,"loc":{"start":{"line":1,"column":2599},"end":{"line":1,"column":2651}}})) != null ? stack1 : "")
    + "\"> "
    + alias2(lookupProperty(helpers,"getIcon").call(alias3,(depth0 != null ? lookupProperty(depth0,"icon") : depth0),{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":2654},"end":{"line":1,"column":2670}}}))
    + " </a> ";
},"27":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"theme") : depth0), depth0));
},"29":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda(((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"theme")), depth0));
},"31":function(container,depth0,helpers,partials,data) {
    return " <li class=\"divider\"></li> ";
},"33":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <li> <a href=\"#\" aria-label=\"search\" action=\"search\" class=\"type-icon button ux4 nav-link large\" theme=\""
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"theme") : depth0), depth0))
    + "\">"
    + alias1(lookupProperty(helpers,"getIcon").call(depth0 != null ? depth0 : (container.nullContext || {}),"magnifying-glass",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":2892},"end":{"line":1,"column":2922}}}))
    + "</a> </li> ";
},"35":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <li class=\"menu\" theme=\""
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"theme") : depth0), depth0))
    + "\"> <a href=\"#\" name=\"menu-link\" role=\"button\" aria-label=\"show/hide main menu\" action=\"menu\" class=\"type-icon\" aria-expanded=\"false\"> <div class=\"initials\" translate=\"no\"> <span class=\"label\"></span> </div> "
    + alias1(lookupProperty(helpers,"getIcon").call(depth0 != null ? depth0 : (container.nullContext || {}),"menu",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":3326},"end":{"line":1,"column":3344}}}))
    + " </a> </li> ";
},"37":function(container,depth0,helpers,partials,data) {
    return " <div name=\"menu-overlay\" action=\"close-menu\"></div> <div name=\"side-drawer\" role=\"dialog\" aria-modal=\"true\" aria-label=\"Main Menu\"></div> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"content\"> <ul class=\"links links-left\"> "
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"leftLinks") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":52},"end":{"line":1,"column":823}}})) != null ? stack1 : "")
    + " </ul> <ul class=\"links links-center hide-mobile user-links\"> <li> <a id=\"wallet\" href=\"/home/events\" aria-label=\"my wallet\" class=\"button ux4 large nav-link\" theme=\""
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"theme") : depth0), depth0))
    + "\"> "
    + alias3(lookupProperty(helpers,"getIcon").call(alias1,"wallet-new",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":1001},"end":{"line":1,"column":1025}}}))
    + "<span class=\"button-label\">Wallet</span> </a> </li> <li> <a id=\"media\" href=\"/home/media\" aria-label=\"my media\" class=\"button ux4 large nav-link\" theme=\""
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"theme") : depth0), depth0))
    + "\"> "
    + alias3(lookupProperty(helpers,"getIcon").call(alias1,"play-circle-open",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":1190},"end":{"line":1,"column":1220}}}))
    + "<span class=\"button-label\">Media</span> </a> </li> <li> <a id=\"account\" href=\"/home\" aria-label=\"my account\" class=\"button ux4 large nav-link\" theme=\""
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"theme") : depth0), depth0))
    + "\"> "
    + alias3(lookupProperty(helpers,"getIcon").call(alias1,"profile",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":1382},"end":{"line":1,"column":1403}}}))
    + "<span class=\"button-label\">Account</span> </a> </li> </ul> <ul class=\"links links-right\"> "
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"rightLinks") : depth0),{"name":"each","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1493},"end":{"line":1,"column":2704}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"rightLinks") : depth0),{"name":"if","hash":{},"fn":container.program(31, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":2705},"end":{"line":1,"column":2757}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showSearch") : depth0),{"name":"if","hash":{},"fn":container.program(33, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":2758},"end":{"line":1,"column":2940}}})) != null ? stack1 : "")
    + " <li class=\"login hide-mobile\"> <a href=\"#\" action=\"login\" class=\"button ux4 primary small\" theme=\""
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"theme") : depth0), depth0))
    + "\">Log In</a> </li> "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showAvatar") : depth0),{"name":"if","hash":{},"fn":container.program(35, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":3067},"end":{"line":1,"column":3363}}})) != null ? stack1 : "")
    + " </ul> </div> "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showAvatar") : depth0),{"name":"if","hash":{},"fn":container.program(37, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":3377},"end":{"line":1,"column":3541}}})) != null ? stack1 : "");
},"useData":true});

return this["Templates"];

});
//# sourceMappingURL=PageHeader.js.map